// extracted by mini-css-extract-plugin
module.exports = {"form":"Header_form__2w7xf","nameInput":"Header_nameInput__1Abuv"};